import { Field, Image, ImageField, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentWithContextProps } from 'lib/ComponentProps';

import styles from './PageTitleWithImage.module.css';

type PageTitleWithImageContext = ComponentWithContextProps & {
	route: {
		fields: {
			PageTitle: Field<string>;
			PageImage: Field<ImageField>;
		};
	};
	fields: {
		Title: Field<string>;
	};
};

export default function PageTitleWithImage(props: PageTitleWithImageContext): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<PageTitleWithImageContext>();
	const field = props.fields?.Title ?? sitecoreContext.route.fields.PageTitle;

	return (
		<section className={`${styles.imageHeader} greyLight padY`}>
			<header className={styles.header}>
				<div className={styles.imageContainer}>
					<Image media={sitecoreContext.route.fields.PageImage} />
				</div>
				<Text tag="h1" field={field} className={`${styles.title} padX`} />
			</header>
		</section>
	);
}
